<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-invoices'>{{translations('navbar.sale_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-invoices'>{{translations('invoice.archive_invoice')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('invoice.billing_detail')}}</li>

      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <div class='form-inline mb-4'>
            <div class='form-group mr-3'>
              <button data-toggle='modal' data-target='#InvoicesDetailsModal' class='btn btn-primary' :disabled="(Number(billingInfo.billing_status) !== 1)">{{translations('invoice.deposit_processing')}}</button><!-- 1:入金待ち,2:入金済,3:未請求 -->
            </div>
            <div class="form-group">
              <a class="btn btn-link btn-sm decoration-underline" href="#" @click="openBillingPdf()">{{translations('invoice.invoice_pdf_output')}}<i class="fas fa-external-link-alt"></i></a>
            </div>
          </div>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('invoice.billing_date')}}</th>
                <td>{{ $invoiceTools.formatDateAt(billingInfo.billed_at) }}</td>
              </tr>
              <tr>
                <th>{{translations('invoice.billing_number')}}</th>
                <td>{{billingInfo.billing_number}}</td>
              </tr>
              <tr>
                <th>{{translations('invoice.supplier')}}</th>
                <td>{{billingInfo.client_name}}</td>
              </tr>
              <tr>
                <th>{{translations('invoice.remarks')}}</th>
                <td>
                  <button
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-memo'
                    data-placement='right'
                  >{{ billingInfo.memo ? billingInfo.memo : '-----------' }}</button>
                  <div id='popover-memo' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x' @click="tempMemo=billingInfo.memo">&times;</button>{{translations('invoice.remarks')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <textarea v-model="tempMemo" class='form-control'></textarea>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="onchangeMemo">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('common.last_updated_by')}}</th>
                <td>{{billingInfo.updated_by}}</td>
              </tr>
              <tr>
                <th>{{translations('common.last_update_time')}}</th>
                <td>{{ $invoiceTools.formatDateAt(billingInfo.updated_at) }}</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deleteInvoices()" data-href='#'>{{translations('invoice.delete')}}</a>
            </div>
          </div>
          <h5 class='mt-3'>{{translations('invoice.deposit_detail')}}</h5>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-300'>
              <thead>
                <tr>
                  <th>{{translations('invoice.date')}}</th>
                  <th>{{translations('invoice.item_name')}}</th>
                  <th>{{translations('invoice.amount_money')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(detail, i) in paymentDetails">
                  <tr :key="i">
                    <td>{{ $invoiceTools.formatDateAt(detail.paid_at).slice(0, 10) }}</td>
                    <td>{{ detail.item_name }}</td>
                    <td>{{ Number(detail.paid).toLocaleString() }}</td>
                  </tr>
                </template>
                <tr>
                  <td>{{translations('invoice.receipt_total')}}</td>
                  <td></td>
                  <td>{{ paymentSum.toLocaleString() }}</td>
                </tr>
                <tr>
                  <td>{{translations('invoice.remaining_amount')}}</td>
                  <td></td>
                  <td>{{ (Number(paymentSum) - Number(balance)).toLocaleString() }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end">
            <div v-if="taxIncluded" class="text-danger">{{translations('common.tax_included')}}</div>
            <div v-else>{{translations('common.tax_excluded')}}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-800'>
              <thead>
                <tr>
                  <th>{{translations('invoice.document_date')}}</th>
                  <th>{{translations('invoice.slip_number')}}</th>
                  <th>{{translations('invoice.model')}}</th>
                  <th>{{translations('invoice.quantity')}}</th>
                  <th>{{translations('invoice.client_order_number')}}</th>
                  <th>{{translations('invoice.summary')}}</th>
                  <th>{{translations('invoice.tax_classification')}}</th>
                  <th>{{translations('invoice.consumption_tax')}}</th>
                  <th>{{translations('invoice.total_amount')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(detail, i) in billingDetails">
                  <tr :key="i">
                    <td>{{ detail.sold_at }}</td>
                    <td>{{ detail.sales_number }}</td>
                    <td>{{ detail.type_number }}</td>
                    <td class="right">{{ Number(detail.quantity).toLocaleString() }}</td>
                    <td>{{ detail.client_order_number }}</td>
                    <td>{{ detail.remarks }}</td>
                    <td>{{ Number(detail.taxclass_id) === 2 ? translations('invoice.not_applicable') : translations('invoice.taxable_item') }}</td>
                    <td class="right">{{ Number(detail.taxclass_id) === 2 ? '-' : detail.tax_rate + '%' }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="right">{{translations('invoice.purchase_total')}}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                </tr>
                <tr class='bg-lightgreen'>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="right">{{translations('invoice.amount_carried_forward')}}</td>
                  <td class='font-weight-bold right'>{{amountCarriedForward.toLocaleString()}}</td>
                </tr>
                <tr class='bg-lightgreen'>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="right">{{translations('invoice.billing_amount')}}</td>
                  <td class='font-weight-bold right'>{{ (Number(grandTotalUnitPriceIncTax) + Number(amountCarriedForward)).toLocaleString() }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <InvoicesDetailsModal :billingID="billingID" :client="billingInfo.client_name" @paid="getBillings"/>
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import InvoicesDetailsModal from '@/components/InvoicesDetailsModal'
import { mapState } from 'vuex'

export default {
  name: 'SingleOrders',
  props: {},
  components: {
    VueElementLoading,
    InvoicesDetailsModal
  },

  data () {
    return {
      taxIncluded: false, // VAT
      billingID: 0,
      billingInfo: {},
      billingDetails: [],
      grandTotalUnitPrice: null,
      grandTotalUnitPriceIncTax: 0,
      isLoading: false,
      tempMemo: '',
      paymentDetails: [],
      balance: 0,
      amountCarriedForward: 0
    }
  },
  created () {
    if (!this.$route.query.billing_id) {
      this.$router.replace('archive-invoices')
      return
    }

    this.isLoading = true
    this.billingID = Number(this.$route.query.billing_id) // 代表ID
    this.getBillings().then(() => {
      this.calcGrandTotals()
      this.popoverButtons()
    }).finally(() => {
      this.isLoading = false
    })
  },

  computed: {
    ...mapState(['currentLanguage']),
    paymentSum () {
      let total = this.paymentDetails.reduce((sum, payment) => {
        return sum + Number(payment.paid)
      }, 0)
      return total
    },
    confirmationDeleteInvoiceMessage () {
      return this.translations('invoice.delete_invoice')
    },
    confirmationSendInvoiceMessage () {
      return this.translations('invoice.message_send')
    },
    confirmButtonText () {
      return this.translations('common.yes')
    },
    cancelButtonText () {
      return this.translations('common.no')
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
      }
      if (!taxIncluded) { // 税込以外
        return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
      } else {
        return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
      }
    },

    getBillings () {
      return this.$http.post(this.$api_url.billing_details, { billing_id: this.billingID }).then(response => {
        const result = response.data
        if (result.status === true) {
          this.billingInfo = result.information
          this.billingDetails = result.details
          this.taxIncluded = result.information.tax_included
          this.paymentDetails = result.payment_details
          this.amountCarriedForward = result.amount_carried_forward
          this.billingDetails.forEach(detail => {
            detail = this.prepareDetails(detail)
          })
          this.tempMemo = this.billingInfo.memo
          this.balance = result.balance
          return Promise.resolve()
        } else {
          this.$toastr.error(result.message)
          this.$router.push('/archive-invoices')
        }
      }).catch(error => {
        console.log('SingleInvoices:getBillings:catch(error): ', error)
        return Promise.reject(new Error(this.translations('invoice.notice_failed')))
      })
    },

    async openBillingPdf () {
      this.isLoading = true

      try {
        const response = await this.$http.post(this.$api_url.show_realtime_billing, { billing_id: this.billingID })
        const result = response.data
        if (result.status === true && result.bill) {
          this.billingInfo.pdf_base64 = result.bill
        } else {
          console.log('SingleBillings:openBillingPdf:status=false: ', result.message)
          this.$toastr.error(result.message)
        }
      } catch (error) {
        console.log('SingleBillings:openBillingPdf:catch(error): ', error)
        this.$toastr.error(this.translations('invoice.notice_failed'))
      }

      const arrBuff = this.__b64ToArrayBuffer(this.billingInfo.pdf_base64.replace('data:application/pdf;base64,', ''))
      const billFile = new Blob([arrBuff], { type: 'application/pdf' })
      const billFileURL = URL.createObjectURL(billFile)
      window.open(billFileURL)
      this.isLoading = false
    },

    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    prepareDetails (data) {
      data.total_unit_price = data.quantity * data.unit_price
      data.total_unit_price_inctax = data.quantity * data.unit_price_inctax

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_unit_price_inctax = data.total_unit_price
      } else {
        if (!this.taxIncluded) { // 税抜
          data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
        } else {
          data.total_unit_price = this.$util.getExcludeTax(data.total_unit_price_inctax, data.tax_rate)
        }
      }
      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalUnitPriceIncTax = 0

      this.billingDetails.forEach(v => {
        if (!this.taxIncluded) { // 税抜
          this.grandTotalUnitPrice += Number(v.total_unit_price)
        } else {
          this.grandTotalUnitPriceIncTax += Number(v.total_unit_price_inctax)
        }
      })

      if (!this.taxIncluded) { // 税抜
        this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
      } else {
        this.grandTotalUnitPrice = this.$util.getExcludeTax(this.grandTotalUnitPriceIncTax, this.taxRate)
      }
    },

    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()} (${Number(valIncTax).toLocaleString()})`
      } else {
        return `${Number(valIncTax).toLocaleString()} (${Number(val).toLocaleString()})`
      }
    },

    updateInvoices () {
      this.$dialog.confirm('この請求を保存しますか?').then(async () => {
        try {
          this.isLoading = true

          let paramUpdate = {
            billing_id: this.billingID,
            information: this.billingInfo,
            details: this.billingDetails
          }
          let updateInvoice = await this.$http.post(this.$api_url.billing_update, paramUpdate)
          let $data = this.$invoiceTools.prepareResult(updateInvoice.data)
          if ($data.success === true) {
            this.$toastr.success('請求更新に成功しました。', 'Success')
          } else {
            this.$toastr.error($data.data, 'エラー')
          }
          this.isLoading = false
        } catch (error) {
          console.log('SingleInvoices:updateInvoices:catch(error): ', error)
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    },

    deleteInvoices () {
      let message = this.confirmationDeleteInvoiceMessage
      // 請求ステータス(1=入金待ち,2=入金済,3=未請求)
      if (Number(this.billingInfo.billing_status) === 1) {
        message = this.confirmationSendInvoiceMessage + ' ' + message
      }
      this.$dialog.confirm(message, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      })
        .then(async () => {
          this.isLoading = true
          try {
            let del = await this.$http.post(this.$api_url.billing_delete, { billing_id: this.billingID })
            let $data = this.$invoiceTools.prepareResult(del.data, '', 'SingleInvoices:deleteInvoices')
            if ($data.success === true) {
              this.$toastr.success(this.translations('invoice.charge_removed'), this.translations('common.success'))
              this.$router.replace('archive-invoices')
              this.isLoading = false
            } else {
              this.$toastr.error($data.data, this.translations('common.error'))
            }
            this.isLoading = false
          } catch (error) {
            this.isLoading = false
            console.log('SingleInvoices:deleteInvoices:catch(error): ', error)
            this.$toastr.error(this.translations('invoice.notice_failed'), this.translations('common.error'))
          }
        }).catch(() => { console.log('Clicked `Cancel`') })
    },

    __b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },

    onchangeMemo () {
      this.isLoading = true
      const params = {
        billing_id: this.billingID,
        memo: this.tempMemo
      }
      const self = this
      this.$http.post(this.$api_url.billing_change_memo, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(this.translations('invoice.updated_notes'), this.translations('common.success'))
          self.billingInfo.memo = response.data.memo
        } else {
          self.$toastr.error(response.data.message, this.translations('invoice.processing_failed'))
          self.billingInfo.memo = response.data.old_memo
          self.tempMemo = response.data.old_memo
        }
      }).finally(function () {
        self.isLoading = false
        window.$('#popover-memo').popoverX('hide')
      })
    }
  }
}
</script>
